<template>
    <div>
        <base-task-status
            :session_id="session.id"
            task_name="income_based_approach"
            :finishedHook="handleTaskStatusFinished"
        />
    </div>
</template>


<script>
import ApiService from "@/components/utils/api.service.js"
import BaseTaskStatus from "./BaseTaskStatus.vue"

export default {
    components: {
        BaseTaskStatus
    },
    props: {
        session: {
            type: Object,
            default: () => {}
        },
    },
    methods: {
        handleTaskStatusFinished: function(task_status) {
            return ApiService
                .get(`/amas/analysis/analysis/api/${this.session.id}/income-based-approach`)
                .then(response => {
                    let url = `/amas/analysis/${this.session.id}/income/calculation`;
                    return `
                    <a href="${url}">
                    <span 
                        class="circle circle-sm bg-success"
                        data-toggle="tooltip" data-original-title="${this.$t("task_details:status:successfully_done")}"
                    >
                        <i class="fa fa-check"></i>
                    </span>
                    </a>
                    `
                })
                .catch(error => {
                    if(error.response.status===404) {
                        return `
                        <span 
                            class="circle circle-sm bg-danger"
                            data-toggle="tooltip" data-original-title="Ni na voljo na izbranih nepremičninah"
                        >
                            /
                        </span>
                        `
                    } else {
                        throw error
                    }
                })
        }
    },
}
</script>